import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { Box, Collapse, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useSWRMutation from "swr/mutation";

import { useAppSelector } from "../../../../../hooks/useRedux";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import { fetcherPost } from "../../../../../services/fetcher";
import { convertToJalali } from "../../../../../utils/functions";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import AnswerList from "./AnswerList";

export default function TicketDetailsPage() {
  const { fullName, ticketDetail } = useAppSelector((state) => state.user);

  const { ticketId } = useParams();
  const [openInputBox, setOpenInputBox] = useState<boolean>(false);
  const [description, setDescription] = useState<string>("");

  const {
    trigger: answerListTrigger,
    data: answerListData,
    isMutating: answerListMutation,
  } = useSWRMutation(
    [`/Ticket/GetTicketRef`, localStorage.getItem("access_token")],

    fetcherPost
  );

  useEffect(() => {
    answerListTrigger({ Id: ticketId });
  }, [answerListTrigger, ticketId]);

  const { trigger: updateTicketTrigger, isMutating: updateTicketIsMutating } =
    useSWRMutation(
      [`/Ticket/AddTicket`, localStorage.getItem("access_token")],

      fetcherPost,
      {
        onSuccess: () => {
          answerListTrigger({ Id: ticketId });
        },
      }
    );
  console.log(ticketDetail);
  const updateTicket = () => {
    updateTicketTrigger({
      refId: ticketId,
      text: description,
    });
    setDescription("");
  };
  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={false} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: "6px",
            p: "12px",
          }}
        >
          <Box sx={{ width: "50%" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
              درخواست کننده:
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{fullName}</Typography>
          </Box>
          {ticketDetail && (
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                بخش:
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                {ticketDetail?.depName}
              </Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            p: "12px",
          }}
        >
          {ticketDetail && (
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ fontSize: "14px" }}>تاریخ ارسال:</Typography>
              <Typography sx={{ fontSize: "14px" }}>
                {ticketDetail?.insertDate &&
                  convertToJalali(ticketDetail.insertDate)}
              </Typography>
            </Box>
          )}
          {answerListData && answerListData.length > 0 && (
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                آخرین بروزرسانی:
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                {convertToJalali(answerListData[0].insertDate)}
              </Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            p: "12px",
          }}
        >
          {ticketDetail && (
            <Box sx={{ width: "50%", ml: "12px" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                موضوع:
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                {ticketDetail.text}
              </Typography>
            </Box>
          )}
          {answerListData && answerListData.length > 0 && (
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                وضعیت:
              </Typography>
              <CustomButton
                title={`${
                  answerListData[0].status === 1
                    ? "در انتظار پاسخ"
                    : "پاسخ پشتیبان"
                }`}
                bgColor={`${
                  answerListData[0].status === 1
                    ? "primary.light"
                    : "success.light"
                }`}
                // color={`${
                //   answerListData[0].status === 1
                //     ? "primary.main"
                //     : "success.main"
                // }`}
                px="8px"
                fSize="12px"
                mt="4px"
                justifyContent="center"
                borderRadius="8px"
                disableRipple
                disableShadow
              />
            </Box>
          )}
        </Box>

        <Box
          sx={{
            bgcolor: "background.default",
            p: "12px 12px 14px 12px",
            mt: "14px",
            mx: "4px",
            borderRadius: "12px",
            boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.05) ",
            mb: "28px",
          }}
        >
          <Box
            onClick={() => setOpenInputBox(!openInputBox)}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              mb: openInputBox ? "12px" : "0px",
            }}
          >
            {/* <Plus2SVG color={theme.palette.success.main} size={34} /> */}
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                mr: "8px",
                cursor: "pointer",
              }}
            >
              ارسال پاسخ جدید
            </Typography>
            <ArrowDropDownRoundedIcon
              sx={{
                mr: "auto",
                fontSize: "34px",
                color: "darkStatic.light",
                transform: openInputBox ? "scaleY(-1)" : "none",
              }}
            />
          </Box>

          <Collapse in={openInputBox}>
            <CustomInput
              value={description}
              handelChange={(e) => setDescription(e.target.value)}
              name="description"
              placHolder="پاسخ خود را در این قسمت وارد کنید"
              textArea
            />

            <Box sx={{ display: "flex" }}>
              <CustomButton
                onClick={updateTicket}
                title="ارسال پاسخ"
                bgColor="primary.main"
                // color='lightStatic.main'
                px="10px"
                fSize="13px"
                height="44px"
                mr="auto"
                mt="12px"
                disabled={updateTicketIsMutating || !description}
                loading={updateTicketIsMutating}
              />
            </Box>
          </Collapse>
        </Box>

        <AnswerList
          answerListData={answerListData}
          answerListMutation={answerListMutation}
        />
      </Box>
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 700,
          fontSize: "16px",
        }}
      >
        پشتیبانی{" "}
      </Typography>
      <ArrowTickLeft color={grey[800]} size={16} />
      <Typography
        sx={{
          color: "secondary.main",
          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        پاسخ به تیکت
      </Typography>
    </Box>
  );
}
